export {default} from '../Backoffice/TextLink';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/TextLink/index.js